<div style="padding: 20px 22px 16px 22px; min-width: 680px; max-width: 820px;">
  <!-- Header -->
  <div class="flex items-center gap-2 mb-3">
    <mat-icon style="color: #1C593D;">calculate</mat-icon>
    <h2 style="font-size: 1rem; font-weight: 800; color: #1e5a3f; margin: 0;">Simular {{ data.flowLabel }}</h2>
    <button type="button" (click)="close()" class="ml-auto"
      style="display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border: none; background: transparent; color: #9ca3af; cursor: pointer; border-radius: 6px;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
      <mat-icon style="font-size: 20px; width: 20px; height: 20px;">close</mat-icon>
    </button>
  </div>

  <!-- Destino -->
  <div style="display: flex; align-items: center; gap: 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 10px 14px; margin-bottom: 14px;">
    <img *ngIf="data.flagIso as iso" [src]="'https://flagcdn.com/32x24/' + iso + '.png'" alt="" width="32" height="24"
      style="border-radius: 3px; border: 1px solid #e5e7eb; flex-shrink: 0;" onerror="this.style.display='none'" />
    <mat-icon *ngIf="!data.flagIso" style="font-size: 24px; width: 24px; height: 24px; color: #9ca3af;">language</mat-icon>
    <div style="flex: 1;">
      <div style="font-family: monospace; font-weight: 800; color: #1e5a3f; font-size: 0.95rem;">{{ data.countryCode }}</div>
      <div style="font-size: 0.78rem; color: #374151; font-weight: 600;">{{ data.destLabel }}</div>
    </div>
    <div style="text-align: right;">
      <div style="font-size: 0.65rem; color: #6b7280; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px;">Tasa Aguacate</div>
      <div style="font-family: monospace; font-weight: 800; color: #166534; font-size: 0.85rem;">
        1 {{ data.sourceCurrency | uppercase }} → {{ aguacateRate | number:'1.2-8' }} {{ data.destCurrency }}
      </div>
    </div>
  </div>

  <!-- Inputs editables en vivo -->
  <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 14px;">
    <!-- Monto -->
    <div>
      <label style="display: block; font-size: 0.7rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 6px;">
        Monto a enviar
      </label>
      <div style="display: flex; align-items: center; gap: 8px; border: 2px solid #bbf7d0; border-radius: 10px; padding: 8px 12px; background: white;">
        <input type="number" [(ngModel)]="amount" min="0" step="1"
          style="flex: 1; min-width: 0; border: none; outline: none; background: transparent; font-size: 1.05rem; font-weight: 800; color: #1e5a3f; font-family: monospace;" />
        <span style="font-family: monospace; font-weight: 700; color: #6b7280; font-size: 0.82rem;">{{ data.sourceCurrency | uppercase }}</span>
      </div>
      <div *ngIf="belowMin" style="display: flex; align-items: center; gap: 4px; margin-top: 4px; font-size: 0.68rem; color: #d97706; font-weight: 600;">
        <mat-icon style="font-size: 12px; width: 12px; height: 12px;">warning</mat-icon>
        Mínimo: {{ data.minAmount | number:'1.0-2' }} {{ data.sourceCurrency | uppercase }}
      </div>
    </div>

    <!-- Tasa Vita editable -->
    <div>
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;">
        <label style="font-size: 0.7rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px;">
          Tasa Vita
        </label>
        <button *ngIf="vitaRateModified" type="button" (click)="resetVitaRate()"
          title="Restablecer tasa original"
          style="display: inline-flex; align-items: center; gap: 2px; padding: 1px 6px; border: 1px solid #bbf7d0; background: #f0fdf4; color: #166534; font-size: 0.6rem; font-weight: 700; border-radius: 6px; cursor: pointer;">
          <mat-icon style="font-size: 10px; width: 10px; height: 10px;">restart_alt</mat-icon>
          Original
        </button>
      </div>
      <div style="display: flex; align-items: center; gap: 8px; border: 2px solid #bbf7d0; border-radius: 10px; padding: 8px 12px; background: white;"
        [style.border-color]="vitaRateInvalid ? '#fecaca' : (vitaRateModified ? '#fbbf24' : '#bbf7d0')">
        <input type="number" [(ngModel)]="vitaRate" min="0" step="any"
          style="flex: 1; min-width: 0; border: none; outline: none; background: transparent; font-size: 1.05rem; font-weight: 800; color: #166534; font-family: monospace;" />
        <span style="font-family: monospace; font-weight: 700; color: #6b7280; font-size: 0.82rem;">{{ data.destCurrency }}</span>
      </div>
      <div *ngIf="vitaRateInvalid" style="margin-top: 4px; font-size: 0.68rem; color: #b91c1c; font-weight: 600;">
        Tasa debe ser mayor a 0
      </div>
      <div *ngIf="vitaRateModified && !vitaRateInvalid" style="margin-top: 4px; font-size: 0.68rem; color: #b45309; font-weight: 600;">
        Original: {{ originalVitaRate | number:'1.2-8' }}
      </div>
    </div>

    <!-- Markup Aguacate -->
    <div>
      <label style="display: block; font-size: 0.7rem; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 6px;">
        Markup Aguacate
      </label>
      <div style="display: flex; align-items: center; gap: 8px; border: 2px solid #e9d5ff; border-radius: 10px; padding: 8px 12px; background: white;"
        [style.border-color]="markupInvalid ? '#fecaca' : '#e9d5ff'">
        <input type="number" [(ngModel)]="markupPct" min="-100" max="100" step="0.1"
          style="flex: 1; min-width: 0; border: none; outline: none; background: transparent; font-size: 1.05rem; font-weight: 800; color: #7c3aed; font-family: monospace;" />
        <span style="font-family: monospace; font-weight: 700; color: #6b7280; font-size: 0.82rem;">%</span>
      </div>
      <div *ngIf="markupInvalid" style="margin-top: 4px; font-size: 0.68rem; color: #b91c1c; font-weight: 600;">
        Ingrese un valor entre -100 y 100
      </div>
      <div *ngIf="!markupInvalid && markupPct < 0" style="margin-top: 4px; font-size: 0.68rem; color: #b45309; font-weight: 600;">
        Subsidio — Aguacate paga la diferencia
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <!-- BLOQUE CLIENTE — qué paga, qué recibe                                 -->
  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <div *ngIf="!vitaRateInvalid" style="background: white; border: 2px solid #bfdbfe; border-radius: 12px; padding: 14px 16px; margin-bottom: 12px;">
    <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 10px;">
      <mat-icon style="color: #2563eb; font-size: 18px; width: 18px; height: 18px;">person</mat-icon>
      <div style="font-size: 0.78rem; font-weight: 800; color: #1e40af; text-transform: uppercase; letter-spacing: 0.4px;">
        Cliente
      </div>
    </div>

    <!-- Línea: envía -->
    <div style="display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px dashed #e5e7eb;">
      <div style="flex: 1; font-size: 0.74rem; color: #374151; font-weight: 600;">
        Envía
      </div>
      <div style="font-family: monospace; font-size: 0.9rem; color: #1e40af; font-weight: 800;">
        {{ amount || 0 | number:'1.2-2' }} {{ data.sourceCurrency | uppercase }}
      </div>
    </div>

    <!-- Línea: conversión a tasa Aguacate -->
    <div style="display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px dashed #e5e7eb;">
      <div style="flex: 1; display: flex; align-items: center; gap: 6px; font-size: 0.72rem; color: #6b7280; font-weight: 600;">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #9ca3af;">trending_flat</mat-icon>
        {{ data.sourceCurrency | uppercase }} → {{ data.destCurrency }} a tasa Aguacate
        <span style="font-family: monospace; color: #6b7280;">@ {{ aguacateRate | number:'1.2-8' }}</span>
      </div>
      <div style="font-family: monospace; font-size: 0.85rem; color: #1e3a8a; font-weight: 700;">
        = {{ grossAguacateDest | number:'1.2-2' }} {{ data.destCurrency }}
      </div>
    </div>

    <!-- Línea: fee Vita (siempre visible) -->
    <div style="display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px dashed #e5e7eb;">
      <div style="flex: 1; display: flex; align-items: center; gap: 6px; font-size: 0.72rem; font-weight: 600;"
        [style.color]="data.fixedCost > 0 ? '#b45309' : '#6b7280'">
        <mat-icon style="font-size: 14px; width: 14px; height: 14px;"
          [style.color]="data.fixedCost > 0 ? '#d97706' : '#9ca3af'">paid</mat-icon>
        Fee fijo Vita (a cargo del cliente)
        <span *ngIf="data.fixedCost === 0" style="font-size: 0.66rem; color: #9ca3af; font-weight: 600;">— este rail no cobra fee fijo</span>
      </div>
      <div style="font-family: monospace; font-size: 0.85rem; font-weight: 800;"
        [style.color]="data.fixedCost > 0 ? '#b45309' : '#9ca3af'">
        {{ data.fixedCost > 0 ? '− ' : '' }}{{ data.fixedCost | number:'1.2-2' }} {{ data.destCurrency }}
      </div>
    </div>

    <!-- Total: cliente recibe -->
    <div style="display: flex; align-items: center; gap: 10px; padding: 10px 0 4px 0;">
      <div style="display: flex; align-items: center; gap: 6px;">
        <mat-icon style="color: #1e40af; font-size: 18px; width: 18px; height: 18px;">check_circle</mat-icon>
        <div style="font-size: 0.84rem; font-weight: 800; color: #1e40af; text-transform: uppercase; letter-spacing: 0.4px;">
          Cliente recibe
        </div>
      </div>
      <div class="ml-auto" style="font-family: monospace; font-size: 1.3rem; color: #1e3a8a; font-weight: 900;">
        {{ aguacateReceive | number:'1.2-2' }} {{ data.destCurrency }}
      </div>
    </div>

    <!-- Plazo (solo si viene en data) -->
    <div *ngIf="data.businessDays !== undefined && data.businessDays !== null"
      style="margin-top: 8px; padding-top: 8px; border-top: 1px dashed #e5e7eb; display: flex; justify-content: space-between; align-items: center; font-size: 0.7rem; color: #6b7280;">
      <span style="display: flex; align-items: center; gap: 4px;">
        <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #9ca3af;">schedule</mat-icon>
        Plazo estimado
      </span>
      <span style="font-weight: 700; color: #374151;">{{ data.businessDays }} día(s) hábil(es)</span>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <!-- BLOQUE AGUACATE — qué gana                                            -->
  <!-- ═══════════════════════════════════════════════════════════════════ -->
  <div *ngIf="!vitaRateInvalid && !markupInvalid" style="border-radius: 12px; padding: 14px 16px;"
    [style.background]="markupPct < 0 ? 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)' : 'linear-gradient(135deg, #f0fdf4 0%, #d1fae5 100%)'"
    [style.border]="markupPct < 0 ? '2px solid #d97706' : '2px solid #1C593D'">
    <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 10px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
        [style.color]="markupPct < 0 ? '#b45309' : '#1C593D'">paid</mat-icon>
      <div style="font-size: 0.78rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.4px;"
        [style.color]="markupPct < 0 ? '#92400e' : '#1e5a3f'">
        Aguacate {{ markupPct < 0 ? '(pérdida)' : '' }}
      </div>
      <div class="ml-auto" style="display: flex; align-items: center; gap: 8px;">
        <div style="font-family: monospace; font-size: 0.66rem; font-weight: 700; background: white; padding: 2px 8px; border-radius: 6px;"
          [style.color]="markupPct < 0 ? '#92400e' : '#1e5a3f'"
          [style.border]="markupPct < 0 ? '1px solid #fde68a' : '1px solid #bbf7d0'">
          Tasa Vita: {{ vitaRate | number:'1.2-8' }}
        </div>
        <div style="font-family: monospace; font-size: 0.66rem; font-weight: 700; background: white; padding: 2px 8px; border-radius: 6px;"
          [style.color]="markupPct < 0 ? '#92400e' : '#1e5a3f'"
          [style.border]="markupPct < 0 ? '1px solid #fde68a' : '1px solid #bbf7d0'">
          Tasa Aguacate: {{ aguacateRate | number:'1.2-8' }}
        </div>
      </div>
    </div>

    <!-- Spread explicado -->
    <div style="background: white; border-radius: 8px; padding: 8px 12px; margin-bottom: 10px;"
      [style.border]="markupPct < 0 ? '1px solid #fde68a' : '1px solid #bbf7d0'">
      <div style="display: flex; align-items: center; gap: 10px; font-size: 0.7rem; color: #374151; font-weight: 600;">
        <span>Spread capturado:</span>
        <span style="font-family: monospace; font-weight: 800;"
          [style.color]="markupPct < 0 ? '#92400e' : '#065f46'">
          ({{ vitaRate | number:'1.2-8' }} − {{ aguacateRate | number:'1.2-8' }}) × {{ amount || 0 | number:'1.2-2' }} {{ data.sourceCurrency | uppercase }}
        </span>
      </div>
    </div>

    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px;">
      <!-- Profit en moneda origen (KPI principal) -->
      <div style="background: white; border-radius: 10px; padding: 12px;"
        [style.border]="markupPct < 0 ? '2px solid #d97706' : '2px solid #1C593D'">
        <div style="font-size: 0.62rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 4px;"
          [style.color]="markupPct < 0 ? '#92400e' : '#1e5a3f'">
          {{ markupPct < 0 ? 'Pierde' : 'Gana' }} ({{ data.sourceCurrency | uppercase }})
        </div>
        <div style="font-family: monospace; font-size: 1.25rem; font-weight: 900;"
          [style.color]="aguacateProfitUsd >= 0 ? '#065f46' : '#b91c1c'">
          {{ aguacateProfitUsd | number:'1.2-4' }}
        </div>
        <div style="font-size: 0.66rem; color: #6b7280; font-weight: 600;">
          {{ data.sourceCurrency | uppercase }}
        </div>
      </div>

      <!-- Profit en moneda destino -->
      <div style="background: white; border-radius: 10px; padding: 12px;">
        <div style="font-size: 0.62rem; color: #6b7280; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 4px;">
          Equivalente en {{ data.destCurrency }}
        </div>
        <div style="font-family: monospace; font-size: 1.05rem; font-weight: 800;"
          [style.color]="aguacateCommissionDest >= 0 ? '#065f46' : '#b91c1c'">
          {{ aguacateCommissionDest | number:'1.2-2' }}
        </div>
        <div style="font-size: 0.66rem; color: #6b7280; font-weight: 600;">
          {{ data.destCurrency }}
        </div>
      </div>

      <!-- Markup aplicado -->
      <div style="background: white; border-radius: 10px; padding: 12px;">
        <div style="font-size: 0.62rem; color: #6b7280; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 4px;">
          Markup aplicado
        </div>
        <div style="font-family: monospace; font-size: 1.05rem; font-weight: 800;"
          [style.color]="markupPct >= 0 ? '#065f46' : '#b91c1c'">
          {{ markupPct | number:'1.1-2' }}%
        </div>
        <div style="font-size: 0.66rem; color: #6b7280; font-weight: 600;">
          sobre tasa Vita
        </div>
      </div>
    </div>

    <!-- Nota aclaratoria sobre el fee -->
    <div style="margin-top: 10px; display: flex; align-items: center; gap: 6px; font-size: 0.68rem; font-weight: 600;"
      [style.color]="markupPct < 0 ? '#92400e' : '#1e5a3f'">
      <mat-icon style="font-size: 12px; width: 12px; height: 12px;">info</mat-icon>
      <span *ngIf="markupPct >= 0">El fee fijo Vita lo paga el cliente — el profit Aguacate es el spread limpio.</span>
      <span *ngIf="markupPct < 0">Markup negativo: Aguacate paga la diferencia para mejorar la tasa al cliente.</span>
    </div>
  </div>
</div>
